import agsDictionaryUrl from '../../../modules/report-template-convert/AGS_USA_Dictionary_2025A.csv';
import type { DemographicOption } from './reportTemplateBuilder.helpers';

const dictionaryColumnIndexes = {
  database: 0,
  topic: 1,
  subtopic: 2,
  detail: 3,
  label: 4,
  description: 5,
  shortDescription: 6,
  nativeGeo: 7,
} as const;

const parseDictionaryCsvRows = (csv: string): ReadonlyArray<ReadonlyArray<string>> => {
  const rows: string[][] = [];
  let row: string[] = [];
  let value = '';
  let isInsideQuote = false;

  for (let index = 0; index < csv.length; index++) {
    const character = csv[index];
    const nextCharacter = csv[index + 1];

    if (character === '"') {
      if (isInsideQuote && nextCharacter === '"') {
        value += character;
        index++;
      }
      else {
        isInsideQuote = !isInsideQuote;
      }

      continue;
    }

    if (character === ';' && !isInsideQuote) {
      row.push(value);
      value = '';
      continue;
    }

    if ((character === '\n' || character === '\r') && !isInsideQuote) {
      if (character === '\r' && nextCharacter === '\n') {
        index++;
      }

      row.push(value);
      if (row.some(cell => cell.trim())) {
        rows.push(row);
      }

      row = [];
      value = '';
      continue;
    }

    value += character;
  }

  if (value || row.length) {
    row.push(value);
    if (row.some(cell => cell.trim())) {
      rows.push(row);
    }
  }

  return rows;
};

const getDictionaryOptionCategory = (columns: ReadonlyArray<string>): string => {
  return [
    columns[dictionaryColumnIndexes.database],
    columns[dictionaryColumnIndexes.topic],
    columns[dictionaryColumnIndexes.subtopic],
    columns[dictionaryColumnIndexes.detail],
  ].filter(Boolean).join(' / ');
};

const createDictionaryDemographicOptions = (dictionaryCsv: string): ReadonlyArray<DemographicOption> => {
  return parseDictionaryCsvRows(dictionaryCsv).slice(1).flatMap(columns => {
    const id = columns[dictionaryColumnIndexes.label]?.trim();

    if (!id) {
      return [];
    }

    return [{
      id,
      label: columns[dictionaryColumnIndexes.description]?.trim() || id,
      category: getDictionaryOptionCategory(columns),
      region: columns[dictionaryColumnIndexes.nativeGeo]?.trim() || 'N/A',
    }];
  });
};

export const loadDictionaryDemographicOptions = async (): Promise<ReadonlyArray<DemographicOption>> => {
  const response = await fetch(agsDictionaryUrl);

  if (!response.ok) {
    throw new Error('Unable to load AGS dictionary.');
  }

  return createDictionaryDemographicOptions(await response.text());
};
